import { useTranslation } from 'react-i18next';

import QRFullLogo from '~/assets/icons/logo/logo-on-dark.svg?react';
import { Link } from '~/components/ui/link';
import { Text } from '~/components/ui/text';
import { PATH } from '~/constants/route-path';
import { COLORS } from '~/styles/colors';

import { FooterBottom, FooterSection, FooterSections, LogoSection, StyledContainer, StyledDivider } from './styled';

export default function FooterPublic() {
  const { t } = useTranslation();

  return (
    <StyledContainer>
      <div className="customContainer">
        <FooterSections>
          <LogoSection>
            <div style={{ marginBottom: '16px' }}>
              <QRFullLogo />
            </div>
            <Text sx={{ marginRight: '20px', color: COLORS.white }} variant="t16Regular">
              {t('landing:footer.generateTitle')}
            </Text>
          </LogoSection>

          <FooterSection>
            <Text sx={{ mb: 2, color: COLORS.white }} variant="h3">
              {t('common:services')}
            </Text>
            <Link to={PATH.UNAUTH.MAIN} color="white" fontSize={16} fontWeight={400}>
              {t('common:createQrCodes')}
            </Link>
            <div style={{ marginBottom: '16px' }} />
            <Link to={PATH.UNAUTH.PRICES_AND_PLANS} color="white" fontSize={16} fontWeight={400}>
              {t('landing:footer.pricePlan')}
            </Link>
            <div style={{ marginBottom: '16px' }} />
          </FooterSection>

          <FooterSection>
            <Text sx={{ mb: 2, color: COLORS.white }} variant="h3">
              {t('landing:footer.company')}
            </Text>
            <Link to={PATH.TOS} color="white" fontSize={16} fontWeight={400}>
              {t('landing:footer.tos')}
            </Link>
            <div style={{ marginBottom: '16px' }} />
            <Link to={PATH.UNAUTH.PRIVACY_POLICY} color="white" fontSize={16} fontWeight={400}>
              {t('landing:footer.privacy')}
            </Link>
          </FooterSection>

          <FooterSection>
            <Text sx={{ mb: 2, color: COLORS.white }} variant="h3">
              {t('landing:footer.help')}
            </Text>
            <Link to={PATH.UNAUTH.DATA_DELETION} color="white" fontSize={16} fontWeight={400}>
              {t('landing:footer.dataDeletion')}
            </Link>
            <div style={{ marginBottom: '16px' }} />
            <Link to={PATH.UNAUTH.FAQ} color="white" fontSize={16} fontWeight={400}>
              {t('landing:footer.faq')}
            </Link>
            <div style={{ marginBottom: '16px' }} />
            <Link to="/contact-us" color="white" fontSize={16} fontWeight={400}>
              {t('landing:footer.contact')}
            </Link>
          </FooterSection>
        </FooterSections>

        <StyledDivider />

        <FooterBottom>
          <Text sx={{ textAlign: 'center', color: COLORS.white }} variant="input15">
            {new Date().getFullYear()} © {t('landing:footer.copy')}
          </Text>
        </FooterBottom>
      </div>
    </StyledContainer>
  );
}
